"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
var constants_1 = require("../constants");
/**
 * Request events are sent when we start dealing with one of the external services
 * that are involved in our ad stack. This means when we start doing header bidding
 * with index, or prebid, as well as when we talk to adzerk to see if we should
 * render our auction winner, or something from their end.
 * in:
 *   adUnitId: the id on the div that this ad is going to render in
 *   adPartner: the name of the "partner" that we are talking to about the ad for the adUnitId
 *   placementDetail: this is an object that contains some adzerk config for the ad
 * out:
 *   this function returns a UUID for the event that was sent
 * side effects:
 *   this function copies the the page, storyId and partId from window.ads into a cache specific
 *   to this adUnitId.  It ads the partner, and the id for this request to that cache as well.
 */
var sendRequest = function (adUnitId, adPartner, placementDetail) {
    var _a;
    // copy page, story_id and page_id from the cache into the ad specific cache
    window.ads = window.ads || {};
    window.ads[adUnitId] = window.ads[adUnitId] || {};
    var page = (window.ads[adUnitId]["page"] = window.ads["page"]);
    var storyId = (window.ads[adUnitId]["story_id"] = window.ads["story_id"]);
    var partId = (window.ads[adUnitId]["part_id"] = window.ads["part_id"]);
    var requestOffset = 0;
    // on the first request event, we cache the time, to be used to calculate offset timing
    // for the events that follow
    if (!Object.prototype.hasOwnProperty.call(window.ads[adUnitId], constants_1.startTimeField)) {
        window.ads[adUnitId][constants_1.startTimeField] = Date.now();
    }
    else {
        requestOffset = Date.now() - window.ads[adUnitId][constants_1.startTimeField];
    }
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId);
    // request specific fields
    message.zone_id = (placementDetail === null || placementDetail === void 0 ? void 0 : placementDetail.zoneId)
        ? placementDetail.zoneId.toString()
        : (placementDetail === null || placementDetail === void 0 ? void 0 : placementDetail.zone)
            ? placementDetail.zone.toString()
            : "";
    message.placement =
        (placementDetail === null || placementDetail === void 0 ? void 0 : placementDetail.htSlotName) || (placementDetail === null || placementDetail === void 0 ? void 0 : placementDetail.placement_name);
    message.page_view_id = (_a = window === null || window === void 0 ? void 0 : window.ads) === null || _a === void 0 ? void 0 : _a.page_view_id;
    message.adunit_id = adUnitId;
    message.request_offset = requestOffset;
    // stick these into the cache
    message.ad_partner = window.ads[adUnitId]["ad_partner"] = adPartner;
    window.ads[adUnitId][adPartner + "_request"] = message.id;
    (0, http_1.sendAthaEvent)("request", message);
    return message["id"];
};
exports.default = sendRequest;
